const getOperatorOptions = () => {
  return [
    { label: 'Equals', value: 'equals' },
    { label: 'Does not equal', value: 'does not equal' },
    { label: 'Contains', value: 'contains' },
    { label: 'Does not contain', value: 'does not contain' },
    { label: 'Starts with', value: 'starts with' },
    { label: 'Ends with', value: 'ends with' },
    { label: 'Wildcard match', value: 'glob' },
    { label: 'Is set', value: 'is set' },
    { label: 'Is not set', value: 'is not set' }
  ]
}

const getMathematicalOperatorOptions = () => {
  return [
    { label: 'Equals', value: 'equals' },
    { label: 'Does not equal', value: 'does not equal' },
    { label: 'Greater than', value: 'gt' },
    { label: 'Less than', value: 'lt' },
    { label: 'Greater than or equal to', value: 'gte' },
    { label: 'Less than or equal to', value: 'lte' }
  ]
}

const getOccurenceOptions = () => {
  return [
    { label: 'On most recent occurrence', value: 'last touch' },
    { label: 'On current page', value: 'last' },
    { label: 'On first occurrence', value: 'first touch' },
    { label: 'On first ever page hit', value: 'first' },
    { label: 'On any occurrence', value: 'any' }
  ]
}

const getInclusionOptions = () => {
  return [
    {
      value: 'include any',
      label: 'include any of'
    },
    {
      value: 'do not include any',
      label: "don't include any of"
    },
    { value: 'is set', label: 'matches any' },
    { value: 'is not set', label: "doesn't match any" }
  ]
}

const getDateOperatorOptions = () => {
  return [
    { label: 'Between', value: 'between' },
    { label: 'Equals', value: 'equals' },
    { label: 'Before', value: 'before' },
    { label: 'After', value: 'after' }
  ]
}

const getTimeOperatorOptions = () => {
  return [
    { label: 'Before', value: 'before' },
    { label: 'After', value: 'after' }
  ]
}

/**
 * Operators for event history conditions.
 * Used for segment conditions like "has/hasn't fired event X" or "fired >= N times".
 */
const getEventHistoryOperatorOptions = () => {
  return [
    { label: 'Has fired', value: 'has_fired' },
    { label: 'Has not fired', value: 'has_not_fired' },
    { label: 'Fired at least', value: 'gte' },
    { label: 'Fired less than', value: 'lt' },
    { label: 'Fired exactly', value: 'equals' }
  ]
}

/**
 * Operators for purchase history conditions.
 * Reuses inclusion operators for consistency with tags/lists.
 * - 'include any' / 'do not include any' for specific products
 * - 'is set' / 'is not set' for "has purchased anything" / "has not purchased anything"
 */
const getPurchaseHistoryOperatorOptions = () => {
  return [
    { label: 'Has purchased', value: 'include any' },
    { label: 'Has not purchased', value: 'do not include any' },
    { label: 'Has purchased anything', value: 'is set' },
    { label: 'Has not purchased anything', value: 'is not set' }
  ]
}

export {
  getOperatorOptions,
  getOccurenceOptions,
  getInclusionOptions,
  getDateOperatorOptions,
  getTimeOperatorOptions,
  getMathematicalOperatorOptions,
  getEventHistoryOperatorOptions,
  getPurchaseHistoryOperatorOptions
}
